// extracted by mini-css-extract-plugin
export default {"bookingcard":"BookingCard_bookingcard__MrZXu"};